import { Skeleton } from "@mui/material";
import React from "react";

const MainCardSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      color="#eee"
      width={"100%"}
      height={490}
      style={{ borderRadius: "10px", marginBottom: "20px" }}
    />
  );
};

export default MainCardSkeleton;
